import { styled } from '../../lib/imports';
import { Text } from '../../components';

export const Description = styled(Text)`
  padding: ${({ theme }) => theme.spacings.kilo}; 24px;
`;
